module.exports = __webpack_public_path__ + "static/media/photo13.c56449e8.jpg";